import { DeviceTrackingLogType } from '@/api/apis/route';
import { getLogInformation } from './utils';

type TrackingLogsProps = {
  log: DeviceTrackingLogType;
};

export const TrackingLogs = ({ log }: TrackingLogsProps) => {
  const logsList = getLogInformation(log);

  if (!logsList.length) return null;

  return (
    <div className="flex flex-col p-3 gap-1 rounded bg-base-90">
      {logsList.map((info) => (
        <span key={info} className="text-s-m text-base-5">
          {info}
        </span>
      ))}
    </div>
  );
};
